import React, { useState } from 'react';
import CurrencyType from '../../../currencyType/currencyType';
import NumOfPayment from '../../../numOfPayment/numOfPayment';
import { fetchPaymentDetails } from '../../../../apiCall';

// Utility to parse query params
function useQuery() {
  return React.useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const entries = {};
    for (let [key, value] of params.entries()) {
      entries[key] = value;
    }
    return entries;
  }, []);
}

const PayPerClick = () => {
  const data = useQuery();
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const handlePaymentDetails = () => {
    fetchPaymentDetails((response) => {
      if (response.URL) {
        setIframeUrl(response.URL);
        setShowIframe(true);
      }
    }, 1000, 'hoshen192020@gmail.com', 35454, 1, '+972465', 4, 1);
  };

  return (
    <div className="card summaryCard" style={{ marginLeft: '-10px', maxWidth: 500, margin: 'auto', marginTop: 40 }}>
      <h6 className="headerBack" style={{textAlign:'center'}}>:פרטי נוסע</h6>
      <div className='parameter'>
        <span>{data.name}</span>
        <span style={{ fontWeight: 'bold' }}> : שם </span>
      </div>
      {/* <div className='parameter'>
        <span>{data.englishName}</span>
        <span style={{ fontWeight: 'bold' }}> : שם באנגלית </span>
      </div> */}
      <div className='parameter'>
        <span>{data.amount}</span>
        <span style={{ fontWeight: 'bold' }}> : כמות </span>
      </div>
      <div className='parameter'>
        <span>{data.countryCode}</span><span>{data.phone}</span>
        <span style={{ fontWeight: 'bold' }}> : טלפון </span>
      </div>
      <div className='parameter'>
        <span>{data.secondCountryCode}</span><span>{data.anotherPhone}</span>
        <span style={{ fontWeight: 'bold' }}> : טלפון נוסף </span>
      </div>
      <div className='parameter'>
        <span>{data.notes}</span>
        <span style={{ fontWeight: 'bold' }}> : הערות </span>
      </div>
      <div className='parameter'>
        <span>{data.price}$</span>
        <span style={{ fontWeight: 'bold'}}> : מחיר </span>
      </div>
      <CurrencyType />
      <NumOfPayment />
      <button className='optionsBtn' style={{marginTop: 20}} onClick={handlePaymentDetails}>
        מעבר לתשלום
      </button>
      {showIframe && (
        <div style={{marginTop: 20}}>
          <iframe
            title="payment"
            src={iframeUrl}
            style={{ width: '100%', minHeight: 500, border: '1px solid #ccc', borderRadius: 8 }}
            allow="payment"
          />
        </div>
      )}
    </div>
  );
};

export default PayPerClick;
